import styled from "styled-components";
import { motion } from "framer-motion";
import {
  FaLightbulb,
  FaIndustry,
  FaHandshake,
  FaRocket,
  FaUserTie,
  FaFlask,
  FaLeaf,
  FaGraduationCap,
} from "react-icons/fa";

export default function WhyThisSummitMatters() {
  const leftItems = [
    { icon: <FaIndustry />, text: "Research meets industry application" },
    { icon: <FaLightbulb />, text: "R&D aligns with national priorities" },
    {
      icon: <FaHandshake />,
      text: "Industry-academia collaborations enable scalable technology-led impact",
    },
    {
      icon: <FaRocket />,
      text: "Innovation moves from labs to real-world deployment",
    },
  ];

  const rightItems = [
    {
      icon: <FaUserTie />,
      text: "CEOs and heads from corporate companies and PSUs",
    },
    { icon: <FaFlask />, text: "Business / R&D Heads" },
    { icon: <FaLeaf />, text: "CSR / ESG Heads" },
    {
      icon: <FaGraduationCap />,
      text: "Eminent academicians, researchers, and students from IIT Madras",
    },
  ];

  return (
    <Section>
      <Container>
        <Grid>
          <Column
            as={motion.div}
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <Title>This Summit creates a space where:</Title>

            {leftItems.map((item, i) => (
              <Card key={i}>
                <IconBox>{item.icon}</IconBox>
                {item.text}
              </Card>
            ))}
          </Column>

          <Column
            as={motion.div}
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <Title>Who Should Participate</Title>

            {rightItems.map((item, i) => (
              <Card key={i}>
                <IconBox>{item.icon}</IconBox>
                {item.text}
              </Card>
            ))}
          </Column>
        </Grid>
      </Container>
    </Section>
  );
}

const Section = styled.section`
  padding: 20px;
  background: #fff;

  @media (max-width: 768px) {
    padding: 6px;
  }
`;

const Container = styled.div`
  max-width: 1200px;
  margin: auto;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 14px;
  }
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Title = styled.h2`
  font-size: 24px;
  font-weight: 700;
  color: #791e1b;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    text-align: center;
    font-size: 16px;
    margin-bottom: 2px;
  }
`;

const Card = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  background: #f8f5f2;
  padding: 14px 18px;
  border-radius: 10px;
  border: 1px solid #791e1b;
  font-size: 15px;
  color: #333;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-4px);
    background: #efe7df;
  }

  @media (max-width: 768px) {
    text-align: left;
    font-size: 12px;
    gap: 6px;
    padding: 4px 8px;
  }
`;

const IconBox = styled.div`
  min-width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #791e1b; /* matches your screenshot tone */
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 16px;
  flex-shrink: 0;

  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
`;
